// useGenomeBrowserTranscriptListener.jsx
import { useEffect, useState } from "react";
import TranscriptModal from "../Components/Common/GenomeBrowserTranscriptModal";

export function GenomeBrowserTranscriptListener() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // event is sent from bokeh side, a payload containing gene,transcript,seq, etc.
    function handleBokehEvent(event) {
      setData(event.detail);
    }

    window.addEventListener("bokeh-transcript-selected", handleBokehEvent);
    return () => window.removeEventListener("bokeh-transcript-selected", handleBokehEvent);
  }, []);

  // Remove data when modal is closed
  const handleClose = () => setData(null);

  return (
    <>
      {/* Only show TranscriptModal when data not null */}
      {data && (
        <TranscriptModal
          data={data}
          onClose={handleClose}
        />
      )}
    </>
  );
}
